// Shared constants — ported from code.gs (v1)
// ห้ามแก้ค่าธุรกิจโดยไมี sync กับ QjobPhotome/code.gs จนกว่าจะ cutover
export const JOB_STATUS_AWAITING = 'รอชำระ';
export const JOB_STATUS_COMPLETED = 'เสร็จสิ้น';
export const JOB_STATUS_CANCELLED = 'ยกเลิก';
// Jobs marked as personal use should not affect any accounting/reminder logic.
export const JOB_TYPE_PERSONAL = 'ธุระส่วนตัว';
export const PERSONAL_JOB_TAG = '[PERSONAL]';
export const PAYMENT_DUE_AUTO_MONTHS = 1;
/** Stop LINE payment reminders when overdue longer than this (still shown in UI). */
export const PAYMENT_DUE_LINE_REMINDER_MAX_OVERDUE_MONTHS = 1;
export const DEFAULT_SPREADSHEET_ID = '1D2QLUV9NDNfEdGgrqJIF7eTkcRJQsNatS2KZ2Lyb5bY';
export const DEFAULT_SLIP_ROOT_FOLDER_ID = '1qYaRjw0IWlKRN1qniD8tQlCrqktdvuIj';
export const DEFAULT_QUOTATION_OUTPUT_FOLDER_ID = '1_UDNmChA2tqiqbMBRiHlJ8JwdIRhVVrP';
export const DEFAULT_QUOTATION_OTHER_OUTPUT_FOLDER_ID = '1cHuBC_0C2zmhDXNbOQ_6qjR99qPTCAR_';
export const DEFAULT_PRIMARY_CLIENT_NAME = 'สตาร์ฮันเตอร์ สตูดิโอ';
export const DEFAULT_AUDIT_SHEET_NAME = 'AuditLog';
export const DEFAULT_AUDIT_RETENTION_DAYS = 90;
export const DEFAULT_QUOTATION_TAX_PERCENT = '3';
export const DEFAULT_CONFIGS = [
    { key: 'LINE_API_ENDPOINT', value: 'https://api.line.me/v2/bot/message/push', description: 'LINE Messaging API URL' },
    { key: 'LINE_TOKEN', value: '', description: 'LINE Channel Access Token' },
    { key: 'LINE_CHANNEL_SECRET', value: '', description: 'LINE Channel Secret for webhook signature verification (optional)' },
    { key: 'WEBHOOK_SECRET', value: '', description: 'Secret token for Webhook verification (passed in Webhook URL as ?secret=value) (optional)' },
    { key: 'LINE_WEBHOOK_URL', value: '', description: 'LINE Messaging API Webhook URL (auto-filled — paste into LINE Developers)' },
    { key: 'GOOGLE_CALENDAR_ID', value: '', description: 'Google Calendar ID for syncing' },
    { key: 'GOOGLE_CALENDAR_DISPLAY_IDS', value: '', description: 'Calendar IDs to show together in the web app calendar' },
    {
        key: 'CALENDAR_REMINDERS_JSON',
        value: '{"useDefault":true,"reminders":[{"method":"popup","value":1,"unit":"days"},{"method":"popup","value":4,"unit":"hours"}]}',
        description: 'JSON calendar notification reminders for synced job events',
    },
    { key: 'ADMIN_LINE_ID', value: '', description: 'Admin LINE User ID/Group ID' },
    { key: 'TEAM_LINE_ID', value: '', description: 'LINE User ID/Group ID for team update message' },
    {
        key: 'PAYMENT_REMINDER_DAYS_OF_MONTH',
        value: '',
        description: 'Comma list of days-of-month (1-31) to send the batched payment-due LINE reminder, e.g. "5" or "1,15". Empty = send once, as soon as something is due, up to once a month.',
    },
    { key: 'SLIP_ROOT_FOLDER_ID', value: DEFAULT_SLIP_ROOT_FOLDER_ID, description: 'Google Drive folder ID for uploaded slips' },
    { key: 'QUOTATION_TEMPLATE_FILE_ID', value: '', description: 'Google Sheet template file ID/url (or Drive folder url to auto-pick first Google Sheet)' },
    { key: 'QUOTATION_OUTPUT_FOLDER_ID', value: DEFAULT_QUOTATION_OUTPUT_FOLDER_ID, description: 'Google Drive folder ลูกค้าประจำ (สตาร์ฮันเตอร์) สำหรับใบเสนอราคา/PDF' },
    { key: 'QUOTATION_OTHER_OUTPUT_FOLDER_ID', value: DEFAULT_QUOTATION_OTHER_OUTPUT_FOLDER_ID, description: 'Google Drive folder Production สำหรับลูกค้าอื่น (ใบเสนอราคา/PDF)' },
    { key: 'QUOTATION_TAX_PERCENT', value: DEFAULT_QUOTATION_TAX_PERCENT, description: 'Tax percent for quotation calculation (example: 3)' },
    { key: 'QUOTATION_DEPOSIT_ENABLED', value: 'true', description: 'เปิดใช้งานระบบมัดจำหลายงวดในงานและใบเสนอราคา' },
    { key: 'QUOTATION_PREFIX', value: 'QT', description: 'Quotation number prefix' },
    { key: 'QUOTATION_SHEET_NAME', value: 'Quotation', description: 'Sheet name to render/export as quotation PDF' },
    { key: 'QUOTATION_DATE_CELL', value: 'C2', description: 'Cell for quotation issue date (DD/MM/YYYY)' },
    { key: 'QUOTATION_INPUT_PRICE_CELL', value: '', description: 'Optional hidden/helper cell for input price used by template formulas' },
    { key: 'QUOTATION_DETAIL_START_CELL', value: 'A15', description: 'Start cell where each quotation detail line will be filled' },
    { key: 'QUOTATION_DETAIL_MAX_LINES', value: '8', description: 'Maximum number of detail lines written to quotation' },
    { key: 'QUOTATION_DETAIL_MAX_CHARS_PER_LINE', value: '70', description: 'Maximum chars per line to prevent overflow' },
    { key: 'BUSINESS_NAME', value: '', description: 'ชื่อผู้ให้บริการ / ชื่อธุรกิจ สำหรับแสดงในใบเสนอราคา HTML' },
    { key: 'QUOTATION_PROVIDER_PERSON_NAME', value: '', description: 'ชื่อ-นามสกุลผู้ให้บริการ แสดงใต้ชื่อธุรกิจด้านบนใบเสนอราคา' },
    { key: 'QUOTATION_SHOW_PROVIDER_PERSON_NAME_DEFAULT', value: 'true', description: 'แสดงชื่อ-นามสกุลด้านบนใบเสนอราคาโดยค่าเริ่มต้น' },
    { key: 'QUOTATION_BUSINESS_TEL', value: '', description: 'เบอร์โทรผู้ให้บริการ (แสดงในใบเสนอราคา HTML)' },
    { key: 'QUOTATION_BUSINESS_EMAIL', value: '', description: 'อีเมลผู้ให้บริการ (แสดงในใบเสนอราคา HTML)' },
    { key: 'QUOTATION_DEFAULT_COMPANY_DETAIL', value: '', description: 'ที่อยู่ผู้ให้บริการ EN (แสดงในใบเสนอราคา HTML — บรรทัดใหม่ด้วย \\n)' },
    { key: 'QUOTATION_DEFAULT_COMPANY_DETAIL_TH', value: '', description: 'ที่อยู่ผู้ให้บริการ TH (แสดงในใบเสนอราคา HTML — บรรทัดใหม่ด้วย \\n)' },
    { key: 'QUOTATION_BANK_CODE', value: 'SCB', description: 'รหัสธนาคาร: SCB / KBANK / BBL / KTB / TTB / GSB / BAY / UOB' },
    { key: 'QUOTATION_BANK_ACCOUNT', value: '', description: 'เลขบัญชีธนาคาร' },
    { key: 'QUOTATION_ACCOUNT_NAME', value: '', description: 'ชื่อบัญชีธนาคาร' },
    { key: 'QUOTATION_NATIONAL_ID', value: '', description: 'เลขบัตรประชาชน (สำหรับแสดงในใบเสนอราคา)' },
    {
        key: 'QUOTATION_NOTE_PAYMENT',
        value: 'ชำระเงินภายในสิ้นเดือนที่ออกใบแจ้งหนี้ หากชำระล่าช้าเกินกำหนดจะมีค่าปรับ 1,000 บาท/วัน',
        description: 'หมายเหตุ — เงื่อนไขการชำระเงิน (แก้ได้)',
    },
    {
        key: 'QUOTATION_NOTE_PAYMENT_EN',
        value: 'Payment is due by the end of the invoice month. Late payment may incur a fee of THB 1,000 per day.',
        description: 'Notes — payment terms in English',
    },
    {
        key: 'QUOTATION_NOTE_OWNERSHIP',
        value: 'เมื่อชำระครบถ้วน ลูกค้าได้รับสิทธิ์ความเป็นเจ้าของและสิทธิ์ใช้งานไฟล์สุดท้ายสำหรับวัตถุประสงค์เชิงพาณิชย์ อย่างไรก็ตาม ผู้ให้บริการสงวนสิทธิ์นำผลงานไปแสดงเพื่อ Portfolio และโปรโมทตนเองเท่านั้น',
        description: 'หมายเหตุ — เงื่อนไขความเป็นเจ้าของและสิทธิ์ใช้งาน (แก้ได้)',
    },
    {
        key: 'QUOTATION_NOTE_OWNERSHIP_EN',
        value: 'Upon full payment, the client receives ownership and usage rights to the final deliverables for commercial purposes. The service provider reserves the right to display the work for portfolio and self-promotion only.',
        description: 'Notes — ownership and usage rights in English',
    },
    { key: 'QUOTATION_BANK_TEMPLATES', value: '[]', description: 'JSON array ของบัญชีธนาคาร templates — จัดการผ่าน UI หน้า Settings' },
    { key: 'QUOTATION_CLIENT_TEMPLATES', value: '[]', description: 'JSON array ของ template ข้อมูลลูกค้า — จัดการผ่าน UI หน้า Settings' },
    { key: 'LOCATION_MAP_FAVORITES_JSON', value: '[]', description: 'JSON array ของสถานที่/ลิงก์แผนที่ที่บันทึกไว้ใช้ซ้ำในแบบฟอร์มงาน' },
    { key: 'QUOTATION_LAYOUT_JSON', value: '', description: 'JSON layout template for quotation PDF (custom drag-drop positions)' },
    { key: 'QUOTATION_INCLUDE_SIGNATURE_DEFAULT', value: 'true', description: 'Default include signature on quotation' },
    { key: 'QUOTATION_SIGNATURE_IMAGE_URL', value: 'https://drive.google.com/uc?export=view&id=1QSyUJE5ayvvq-G-1STeEEmN5EEIvYZQ8', description: 'Public image URL used for signature' },
    { key: 'QUOTATION_SIGNATURE_CELL', value: 'C42', description: 'Target cell for signature image' },
    { key: 'QUOTATION_SIGNATURE_IMAGE_WIDTH', value: '160', description: 'Signature image width in pixels' },
    { key: 'QUOTATION_SIGNATURE_IMAGE_HEIGHT', value: '60', description: 'Signature image height in pixels' },
    { key: 'QUOTATION_SIGNATURE_OFFSET_X', value: '0', description: 'Signature horizontal offset in preview/template' },
    { key: 'QUOTATION_SIGNATURE_OFFSET_Y', value: '0', description: 'Signature vertical offset in preview/template' },
    { key: 'AUDIT_SHEET_NAME', value: DEFAULT_AUDIT_SHEET_NAME, description: 'Separate sheet name used for audit/history logs' },
    { key: 'AUDIT_SPREADSHEET_ID', value: DEFAULT_SPREADSHEET_ID, description: 'Spreadsheet ID used for audit/history logs (default: same as Jobs/Settings)' },
    { key: 'AUDIT_RETENTION_DAYS', value: String(DEFAULT_AUDIT_RETENTION_DAYS), description: 'How many days to keep logs (default 90 = 3 months)' },
    { key: 'APP_BASE_URL', value: '', description: 'Web App URL' },
    { key: 'SPREADSHEET_ID', value: DEFAULT_SPREADSHEET_ID, description: 'Target spreadsheet ID used by the app' },
    { key: 'SPREADSHEET_URL', value: '', description: 'Target spreadsheet URL used by the app' },
];
// Canonical → Sheet header aliases (Thai/English)
export const JOB_FIELD_ALIASES = {
    'JobID': ['JobID'],
    'Client': ['Client', 'ลูกค้า'],
    'Contact Name': ['Contact Name', 'ชื่อเรียก', 'ชื่อติดต่อ', 'ชื่อสั้น'],
    'Phone': ['Phone', 'เบอร์โทร'],
    'JobType': ['JobType', 'ประเภทงาน'],
    'Job Name': ['Job Name', 'ชื่องาน'],
    'Event Date': ['Event Date', 'วันที่งาน'],
    'Payment Date': ['Payment Date', 'วันที่ชำระ'],
    'Payment Due Date': ['Payment Due Date', 'กำหนดชำระ'],
    'Item / Job Title': ['Item / Job Title', 'รายการ'],
    'Price per Unit': ['Price per Unit', 'ราคา/หน่วย', 'ราคา', 'ค่าจ้าง', 'ค่าจ้าง (บาท)', 'Wage', 'ราคาที่จ้าง'],
    'Status': ['Status', 'สถานะ (อัตโนมัติ)', 'สถานะ'],
    'Slip Reference': ['Slip Reference', 'อ้างอิงสลิป (อัตโนมัติ)'],
    'Notes': ['Notes', 'โน๊ต (อัตโนมัติ)'],
    'Working Time': ['Working Time', 'เวลางาน'],
    'Event Day Times': ['Event Day Times', 'เวลาแยกตามวัน'],
    'Location': ['Location'],
    'Google Maps Link': ['Google Maps Link'],
    'Color': ['Color', 'สี'],
    'Reminders': ['Reminders', 'การแจ้งเตือน'],
    'Actual Received': ['Actual Received', 'จ่ายจริง', 'ยอดที่จ่าย', 'ได้เงินจริง'],
    'Deposit Schedule': ['Deposit Schedule', 'รายการมัดจำ'],
    'Payment Ledger': ['Payment Ledger', 'ประวัติรับเงิน'],
    'Deposit Enabled': ['Deposit Enabled', 'เปิดงวดชำระ'],
    'Payment Terms': ['Payment Terms', 'เงื่อนไขชำระเงินเฉพาะงาน'],
    'Document History': ['Document History', 'ประวัติเอกสาร'],
    'Create Quotation': ['Create Quotation', 'สร้างใบเสนอราคาอัตโนมัติ'],
    'Quotation Date': ['Quotation Date', 'วันที่ออกใบเสนอราคา'],
    'Quotation Description': ['Quotation Description', 'รายละเอียดงานใบเสนอราคา'],
    'Quotation Company Detail': ['Quotation Company Detail', 'ข้อมูลบริษัท (ใบเสนอราคา)'],
    'Include Signature': ['Include Signature', 'ใส่ลายเซ็นในใบเสนอราคา'],
    'Show Provider Name on Quotation': ['Show Provider Name on Quotation', 'แสดงชื่อผู้ให้บริการในใบเสนอราคา'],
    'Apply Tax': ['Apply Tax', 'หักภาษี ณ ที่จ่าย'],
    'Quotation Number': ['Quotation Number', 'เลขที่ใบเสนอราคา'],
    'Quotation URL': ['Quotation URL', 'ลิงก์ใบเสนอราคา'],
    'Quotation PDF URL': ['Quotation PDF URL', 'ลิงก์ PDF ใบเสนอราคา'],
    'Create Receipt': ['Create Receipt', 'สร้างใบเสร็จรับเงินอัตโนมัติ'],
    'Receipt Number': ['Receipt Number', 'เลขที่ใบเสร็จรับเงิน'],
    'Receipt URL': ['Receipt URL', 'ลิงก์ใบเสร็จรับเงิน'],
    'Receipt PDF URL': ['Receipt PDF URL', 'ลิงก์ PDF ใบเสร็จรับเงิน'],
    'Invoice Number': ['Invoice Number', 'เลขที่ Invoice'],
    'Invoice PDF URL': ['Invoice PDF URL', 'ลิงก์ PDF Invoice'],
    'Folder URL': ['Folder URL', 'ลิงก์โฟลเดอร์งาน'],
    'Document Language': ['Document Language', 'ภาษาเอกสาร'],
    'Show Payment Due on Quotation': ['Show Payment Due on Quotation', 'แสดงกำหนดชำระในใบเสนอราคา'],
    'Payment Due Mode': ['Payment Due Mode', 'โหมดกำหนดชำระ'],
    'Payment Due Notified At': ['Payment Due Notified At', 'แจ้งครบกำหนดชำระแล้ว'],
};
// Sheet header order (used by getJobs/saveJob)
export const JOB_HEADERS = [
    'JobID', 'ลูกค้า', 'ชื่อเรียก', 'เบอร์โทร', 'ประเภทงาน', 'ชื่องาน', 'วันที่งาน', 'วันที่ชำระ', 'กำหนดชำระ', 'รายการ',
    'ราคา/หน่วย', 'สถานะ (อัตโนมัติ)', 'อ้างอิงสลิป (อัตโนมัติ)', 'โน๊ต (อัตโนมัติ)',
    'เวลางาน', 'Location', 'Google Maps Link', 'สี', 'การแจ้งเตือน', 'ได้เงินจริง',
    'สร้างใบเสนอราคาอัตโนมัติ', 'วันที่ออกใบเสนอราคา', 'รายละเอียดงานใบเสนอราคา', 'ข้อมูลบริษัท (ใบเสนอราคา)', 'ใส่ลายเซ็นในใบเสนอราคา', 'แสดงชื่อผู้ให้บริการในใบเสนอราคา', 'หักภาษี ณ ที่จ่าย',
    'เลขที่ใบเสนอราคา', 'ลิงก์ใบเสนอราคา', 'ลิงก์ PDF ใบเสนอราคา',
    'สร้างใบเสร็จรับเงินอัตโนมัติ', 'เลขที่ใบเสร็จรับเงิน', 'ลิงก์ใบเสร็จรับเงิน', 'ลิงก์ PDF ใบเสร็จรับเงิน',
    'เลขที่ Invoice', 'ลิงก์ PDF Invoice', 'ลิงก์โฟลเดอร์งาน',
    'ภาษาเอกสาร', 'แสดงกำหนดชำระในใบเสนอราคา', 'โหมดกำหนดชำระ', 'แจ้งครบกำหนดชำระแล้ว',
    'รายการมัดจำ', 'เวลาแยกตามวัน',
    'ประวัติรับเงิน', 'เงื่อนไขชำระเงินเฉพาะงาน', 'ประวัติเอกสาร', 'เปิดงวดชำระ',
];
/** Short job title for LINE / PDF filenames. Prefers ชื่องาน, else first line of รายการ. */
export function getJobDisplayName(job) {
    if (!job)
        return '';
    const name = String(job['Job Name'] || '').trim();
    if (name)
        return name;
    const itemTitle = String(job['Item / Job Title'] || '').trim();
    if (!itemTitle)
        return '';
    return itemTitle.split(/\r?\n/)[0].trim().replace(/^\d+[.)]\s*/, '');
}
/** Short name for LINE / notify labels — never falls back to company Client. */
export function getJobNotifyClient(job) {
    if (!job)
        return '';
    return String(job['Contact Name'] || '').trim();
}
/** LINE / list label: ชื่อเรียก + job name + job type (skips empty parts; omits company Client). */
export function formatJobNotifyLabel(job) {
    if (!job)
        return '-';
    const client = getJobNotifyClient(job);
    const jobName = getJobDisplayName(job);
    const jobType = String(job.JobType || '').trim();
    const head = [client, jobName].filter(Boolean).join(' ');
    if (head && jobType)
        return `${head} , ${jobType}`;
    return head || jobType || '-';
}
/** Case-insensitive job search — every whitespace-separated token must match. */
export function jobMatchesQuery(job, query) {
    const raw = String(query ?? '').trim().toLowerCase();
    if (!raw)
        return true;
    if (!job)
        return false;
    const haystack = [
        job.JobID,
        job.Client,
        job['Contact Name'],
        job['Job Name'],
        job['Item / Job Title'],
        job.JobType,
        job.Phone,
        job.Location,
        job.Notes,
        job['Quotation Number'],
        job['Invoice Number'],
        job['Receipt Number'],
        job.Status,
    ]
        .map((v) => String(v ?? '').toLowerCase())
        .join(' ');
    const tokens = raw.split(/\s+/).filter(Boolean);
    return tokens.every((token) => haystack.includes(token));
}
//# sourceMappingURL=constants.js.map
